import buttons from './buttons';
import tabs from './tabs';

const overrides = (isRtl, selectedLang) => ({
  ...buttons(isRtl, selectedLang),
  ...tabs(),
});

export default overrides;
